import { Box } from '@mui/material';
import { ControlledShow } from 'framework/show';
import { useListContext } from 'framework/list';
import { InterruptionEmployeeResponseStatus, InterruptionListCardView } from '../../types';
import InterruptionListCard from '../InterruptionListCard';
import EmptyInterruptionList from './EmptyInterruptionList';

const LIST_SX = {
  display: 'flex',
  minHeight: 0,
  flex: 1,
  flexDirection: 'column',
  gap: 1,
  overflowY: 'auto',
  pr: 0.5,
} as const;

type InterruptionListLayoutProps = {
  onUpdateStatus: (id: string, status: InterruptionEmployeeResponseStatus) => Promise<boolean>;
};

const InterruptionListLayout = ({ onUpdateStatus }: InterruptionListLayoutProps) => {
  const { data, loading } = useListContext();
  const items = (data?.items || []) as InterruptionListCardView[];

  if (!loading && items.length === 0) {
    return <EmptyInterruptionList />;
  }

  return (
    <Box sx={LIST_SX}>
      {items.map(item => (
        <ControlledShow key={item.id} data={item}>
          <InterruptionListCard onUpdateStatus={onUpdateStatus} />
        </ControlledShow>
      ))}
    </Box>
  );
};

export default InterruptionListLayout;
